import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import config from '@app/config';
import { SideBar } from '@chama/ui-components';
import ordersIconSrc from '@chama/statics/assets/svg/icon_menu-item-orders.svg';
import storesSearchIconSrc from '@chama/statics/assets/svg/icon_menu-item-search.svg';
import headerLogoSrc from '@chama/statics/assets/svg/mdt-logo.svg';

import './PageSidebar.css';

function PageSidebar({
  onExpandSidebar,
  onRetractSidebar,
  isSidebarExpanded,
  username,
  onLogout,
  isSoundMuted,
  onSoundClick,
  formatMessage,
  currentPath,
}) {
  const isActive = urlToMatch => currentPath === urlToMatch;
  const isOrders = () => isActive('/orders') || (isActive('/') && currentPath.length === 1);

  const links = [
    {
      key: 'orders-link',
      to: '/',
      isActive: isOrders(),
      label: <FormattedMessage id="orders" defaultMessage="Orders" />,
      icon: <img src={ordersIconSrc} alt="orders icon" />,
    },
    {
      key: 'new-dealers-page',
      to: `${config.newMdtHost}/revendedores`,
      isExternal: true,
      label: <FormattedMessage id="dealers.search" />,
      icon: <img src={storesSearchIconSrc} alt="menu stores icon" />,
    },
  ].filter(link => !link.disabled);

  return (
    <div
      className="PageContainer__sidebar_wrapper"
      onMouseEnter={onExpandSidebar}
      onMouseLeave={onRetractSidebar}
    >
      <SideBar
        links={links}
        isSideBarExpanded={isSidebarExpanded}
        username={username}
        logout={onLogout}
        isSoundMuted={isSoundMuted}
        onSoundClick={onSoundClick}
        logo={headerLogoSrc}
        canMuteIndefinitely
        isDark
        welcomeMessage={formatMessage({ id: 'menu_welcome', defaultMessage: 'Welcome,' })}
        logoutTooltipText={formatMessage({
          id: 'logout_confirm_logout',
          defaultMessage: 'Logout',
        })}
        sirenTooltipText={formatMessage({
          id: 'alert_sound',
          defaultMessage: 'Alert sound',
        })}
      />
    </div>
  );
}

PageSidebar.propTypes = {
  onExpandSidebar: PropTypes.func.isRequired,
  onRetractSidebar: PropTypes.func.isRequired,
  isSidebarExpanded: PropTypes.bool.isRequired,
  username: PropTypes.string.isRequired,
  onLogout: PropTypes.func.isRequired,
  isSoundMuted: PropTypes.bool.isRequired,
  onSoundClick: PropTypes.func.isRequired,
  formatMessage: PropTypes.func.isRequired,
  currentPath: PropTypes.string.isRequired,
};

export default React.memo(PageSidebar);



// WEBPACK FOOTER //
// ./src/components/PageSidebar/PageSidebar.layout.jsx